// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--patch-scale:1.009;--patch-scale-reverse:-1.009}.animation-patch{transform:scale(1.009);transform:scale(var(--patch-scale))}.is-mobile .animation-patch{transform:none}.animation-patch-y-reverse{transform:scale(-1.009,1.009);transform:scale(var(--patch-scale-reverse),var(--patch-scale))}.is-mobile .animation-patch-y-reverse{transform:scaleX(-1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
